import {type ModalProps, message, Modal} from 'antd';
import {useForm} from 'form-render';
import Style from './index.module.scss';
import {useMutation, useQuery} from 'react-query';
import {isEmpty} from '../../../../../Stores/commonStore';
import useSchema from 'Utils/Hooks/useSchema';
import JsonForm from 'Components/JsonForm';
import {DataSet} from '../../service';
import {RagFlow} from '../../../RagFlow/service';

interface Props extends ModalProps {
    onOk: () => void;
    id?: string;
}

const Index = ({onOk, id, ...props}: Props) => {
    const form = useForm();

    const onSave = useMutation({
        mutationFn: DataSet.save,
        onSuccess: () => {
            message.success('成功!');
            onOk();
        },
    });

    const getData = useQuery({
        queryKey: ['DataSet.detail', id],
        enabled: !isEmpty(id),
        queryFn: () => DataSet.detail(id!),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    useQuery({
        queryKey: ['RagFlow.detail'],
        queryFn: () => RagFlow.detail(),
        onSuccess: res => {
            form.setValueByPath('externalId', res?.id);
        },
    });

    const {schema} = useSchema({
        type: 'object',
        column: 1,
        displayType: 'row',
        labelCol: 5,
        fieldCol: 18,
        properties: {
            name: {
                title: '名称',
                required: true,
                type: 'string',
            },
            code: {
                title: '编码',
                required: true,
                type: 'string',
                disabled: !isEmpty(id),
            },
            externalId: {
                title: 'RagFlowId',
                disabled: true,
                required: true,
                type: 'number',
            },
            description: {
                type: 'string',
                title: '描述',
                widget: 'textArea',
                column: 1,
            },
            config: {
                title: '配置',
                type: 'string',
                widget: 'textArea',
                required: true,
                rules: [
                    {
                        validator: (_, value) => {
                            if (!value) return false;
                            try {
                                JSON.parse(value);
                                return true;
                            } catch {
                                return false;
                            }
                        },
                        message: '请检查json格式',
                    },
                ],
            },
            status: {
                required: true,
                type: 'boolean',
                title: '启用',
                widget: 'switch',
                defaultValue: true,
            },
        },
    });

    function onFinish(formData: DataSet.Form) {
        if (id) {
            formData.id = id;
        }
        onSave.mutate({...formData});
    }

    return (
        <Modal
            {...props}
            title={`${id ? '编辑' : '新增'}数据集`}
            width={600}
            confirmLoading={onSave.isLoading || getData.isFetching}
            onOk={form.submit}>
            <div className={Style.root}>
                <JsonForm
                    loading={onSave.isLoading || getData.isFetching}
                    onFinish={onFinish}
                    schema={schema}
                    form={form}
                />
            </div>
        </Modal>
    );
};

export default Index;
